import { extendTheme } from "native-base";
import base from "./base";
import components from "./components";
const theme = extendTheme(Object.assign(Object.assign({}, base), { components }));
export default theme;
